/* Meta Pixel: route-gated loader for the FB-Ads landing page variant only.
   Loads fbevents.js once (idempotent) and exposes typed event tracking.
   The pixel ID is public by design (visible in page source anyway). */

const PIXEL_ID = "1793429634144609";
const SCRIPT_ID = "meta-pixel-script";

export const initMetaPixel = () => {
  if (typeof document === "undefined" || document.getElementById(SCRIPT_ID)) return;

  const fbq = (...args) => {
    if (fbq.callMethod) fbq.callMethod(...args);
    else fbq.queue.push(args);
  };
  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = "2.0";

  window.fbq = window.fbq || fbq;
  window._fbq = window.fbq;

  const script = document.createElement("script");
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);

  window.fbq("init", PIXEL_ID);
};

export const trackMetaEvent = (event) => {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", event);
  }
};
